import { render } from "./AudioSegmentation.vue?vue&type=template&id=5dca28af&scoped=true"
import script from "./AudioSegmentation.vue?vue&type=script&lang=js"
export * from "./AudioSegmentation.vue?vue&type=script&lang=js"

import "./AudioSegmentation.vue?vue&type=style&index=0&id=5dca28af&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dca28af"]])

export default __exports__